import React from 'react';
import { Box, Typography } from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../../../components/common/SectionHeader';

export function DescriptionSection({ task }) {
  const { t } = useTranslation(['tasks']);

  return (
    <Box sx={{ mb: 5, '&:last-child': { mb: 0 } }}>
      <SectionHeader icon={DescriptionIcon} title={t('tasks:labels.description')} />
      <Typography
        variant="body1"
        sx={{ lineHeight: 1.7, whiteSpace: 'pre-line', maxHeight: 500, overflowY: 'auto' }}
      >
        {task.description}
      </Typography>
    </Box>
  );
}
